import React from 'react';
import { faTag } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cs from 'classnames';

import FacebookLaunchedIcon from 'shared/components/atoms/FacebookLaunchedIcon';
import FacebookUploadedIcon from 'shared/components/atoms/FacebookUploadedIcon';
import TikTokUploadedIcon from 'shared/components/atoms/TikTokUploadedIcon';
import Tooltip from 'shared/components/atoms/Tooltip';
import { Flex } from 'shared/components/display';

import { COLLECTION_COPY } from 'shared/config/copy';
import { useGalleryListView, VIEWS } from 'shared/hooks/useGalleryListView';
import { BrkfstFile } from 'shared/typings/file';

import styles from './styles';

interface Props {
  file: Pick<BrkfstFile, 'facebookAssetAPNames' | 'isInFacebookAd' | 'tiktokAssetAPNames' | 'tags'>;
  showTags?: boolean;
  showPlatformIconsInGallery?: boolean;
}
const MarketerFileOverlayIcons: React.FC<Props> = ({ file, showTags = false, showPlatformIconsInGallery = true }) => {
  const { viewMode } = useGalleryListView();
  return (
    <Flex
      css={styles}
      className={cs('marketer-file-overlay-icons', {
        'marketer-file-overlay-icons--gallery': viewMode === VIEWS.GALLERY.value,
        'marketer-file-overlay-icons--list': viewMode === VIEWS.LIST.value,
      })}
    >
      {(showPlatformIconsInGallery || viewMode === VIEWS.LIST.value) && (
        <Flex>
          {file.facebookAssetAPNames && <FacebookUploadedIcon showTooltip />}
          {file.isInFacebookAd && <FacebookLaunchedIcon showTooltip />}
          {file.tiktokAssetAPNames && <TikTokUploadedIcon showTooltip />}
        </Flex>
      )}
      {Boolean(file.tags?.length) && showTags && (
        <Tooltip content={COLLECTION_COPY.LABEL_TAGS}>
          <FontAwesomeIcon className="marketer-file-overlay-icons__icon" icon={faTag} />
        </Tooltip>
      )}
    </Flex>
  );
};

export default MarketerFileOverlayIcons;
